import { curry } from "ramda";
import { AccountDescription, AccountId } from "../spread/types";
import { mapAccountDescriptions } from "./accountDescriptions";
import parseFormula from "./formulas/parseFormula";
import reduceFormula from "./formulas/reduceFormula";
import { Formula, ParseResultType, ReducedFormula } from "./formulas/types";
import { AccountMap } from "./types";

export type AccountFormula = ReducedFormula | undefined;
export type AccountFormulas = AccountMap<AccountFormula>;

export const accountFormula = (
  accountDescription: AccountDescription
): AccountFormula | undefined => {
  if (!accountDescription.formula) {
    return undefined;
  }
  const parseResult = parseFormula(accountDescription.formula);
  if (parseResult[0] === ParseResultType.Error) {
    // TODO this should throw an exception ideally
    // throw Error("Unable to parse formula");
    // tslint:disable-next-line
    console.log(accountDescription.formula);
    return undefined;
  }
  return reduceFormula(parseResult[1] as Formula);
};

export const buildAccountFormulas = mapAccountDescriptions(accountFormula);

export const getAccountFormula = curry(
  (accountFormulas: AccountFormulas, id: AccountId) => accountFormulas[id]
);



// WEBPACK FOOTER //
// ./src/spread/model/derivedModel/accountFormulas.ts